import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import BreadcrumbComponent from "../../core/components/breadcrumb/breadcrumb.component";
import ContentHeader from "../../shared/content-header/content-header.component";
import { BreadCrumbInfoModel } from "../../shared/models/breadCrumbInfo.model";
import SideBarComponent from "../../shared/sidebar/sidebar.component";
import { Helmet } from "react-helmet-async";

const ReportComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateTo = (url: string) => {
    if (url) navigate(url);
  };

  const baseBreadCrumbInfo: BreadCrumbInfoModel = {
    label: "Report",
    active: false,
    onClick: () => navigateTo("/report/faultreport"),
  };

  const [breadCrumbInfo, setBreadCrumbInfo] = useState<BreadCrumbInfoModel[]>([
    baseBreadCrumbInfo,
  ]);

  useEffect(() => {
    const { pathname } = location;
    const routeSlice = pathname.slice(
      pathname.indexOf("/report") + "/report".length
    );

    switch (routeSlice) {
      case "/faultreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          { label: "Fault Report", active: true },
        ]);
        break;

      case "/burntimereport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          {
            label: "Burn Time Report",
            active: true,
          },
        ]);
        break;

      case "/motiontrafficreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          {
            label: "Motion Traffic Report",
            active: true,
          },
        ]);
        break;

      case "/motionheatmapreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          {
            label: "Motion Heat Map Report",
            active: true,
          },
        ]);
        break;

      case "/energyreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          {
            label: "Energy Report",
            active: true,
          },
        ]);
        break;

      case "/testreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          { label: "Test Report", active: true },
        ]);
        break;

      case "/useractivityreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          {
            label: "User Activity Report",
            active: true,
          },
        ]);
        break;

      case "/environmentalreport":
        setBreadCrumbInfo([
          baseBreadCrumbInfo,
          {
            label: "Environmental Report",
            active: true,
          },
        ]);
        break;
    }

    if (pathname === "/report") {
      navigate("/report/faultreport");
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Report | SLP</title>
      </Helmet>
      <div>
        <div className="header-container">
          <div className="title-container">
            <ContentHeader
              pageTitle={breadCrumbInfo[breadCrumbInfo.length - 1]?.label}
            ></ContentHeader>
          </div>
        </div>

        <div className="page">
          <div className="page-container mt-4">
            <BreadcrumbComponent breadCrumbInfo={breadCrumbInfo} />
            <div className="flex justify-between">
              <div className="w-lg-25">
                <SideBarComponent moduleName={"Report"} isAccordion={false} />
              </div>
              <div
                className="w-lg-75 bg-card shadow-sm"
                style={{ marginLeft: "1rem" }}
              >
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportComponent;
